import PletlyLogo from './pletly-logo.svg';
import EmptyConnectionsImage from './empty-connections.svg';

export { PletlyLogo, EmptyConnectionsImage };
